import React from "react";
import { useTranslation } from "react-i18next";
import { ModalFooter } from "reactstrap";
import { CheckboxIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { v4 as uuid } from "uuid";
import { mutate } from "swr";
import { toast } from "react-toastify";
import moment from "moment";

import { setIsCreatedCoping } from "../../../store/project/index";
import { store as userStore } from "@components/VerticalLayout/store";
import { setKey } from "../store";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import ErrorToast from "@components/Common/ErrorTost";

type CardFooterCreatedCopingType = {
    rowData: any;
    setIsDataUpdated: React.Dispatch<React.SetStateAction<number | boolean>>;
    shopId: string;
    dataProject: any;
    setSelectedRows: Function;
    designation: string;
    setIsModalLoadingOpened: Function;
    setModalLoadingData: Function;
};

export default function CardFooterCreatedCoping({
    rowData,
    setIsDataUpdated,
    dataProject,
    setSelectedRows,
    designation,
    setIsModalLoadingOpened,
    setModalLoadingData,
}: CardFooterCreatedCopingType) {
    const { t } = useTranslation();
    const {
        userID,
        franchiseID,
        oneShop,
        shopID,
        shopName,
        operatorID,
    } = useSnapshot(userStore);
    const uuidUser = localStorage.getItem("uuidUser");

    async function handleDuplicate() {
        toast.info(
            t(
                "Please note that the template has been updated in accordance with the general settings."
            ),
            {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            }
        );
        setIsModalLoadingOpened(true);
        setModalLoadingData({
            title: "Duplication in progress",
            message: "The duplication of the template is in progress",
        });
        let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/project/duplicateV2`;
        let projectId = uuid();
        let associate: any = {};
        if (!oneShop) {
            rowData.subRows.forEach(async (element: any) => {
                associate[element.id_boutique] = {
                    designation: element[t("Designation")],
                    id_boutique: element.id_boutique,
                };
            });
        } else {
            associate[shopID] = {
                designation: shopName,
                id_boutique: shopID,
                hoursOfUse: "",
            };
        }
        let savedData = {
            userId: userID,
            shopId: "0",
            franchiseId: franchiseID,
            etat: "Dupplication",
            operatorId: operatorID,
            uuidUser: uuidUser,
            itemProject: rowData.projectId,
            isProjectConfigured: rowData.isProjectConfigured,
            designationProject: rowData[t("Designation")],
            data: {
                PROJECT: {
                    project_id: "PROJECT",
                    data_project: {
                        [projectId]: {
                            projectId: projectId,
                            designation: designation,
                            associates: associate,
                            isArchived: false,
                            note: rowData[t("Remark")],
                            nombre: rowData.Nombre,
                            status: "en attente",
                            modified_at: `${moment().format(
                                "DD/MM/YYYY [at] h:mm a"
                            )}`,
                            hour: `${moment().format(
                                "DD/MM/YYYY [at] h:mm a"
                            )}`,
                            name: designation,
                            "Template type": "",
                        },
                    },
                },
            },
        };
        try {
            mutate(
                apiUrl,
                await fetch(apiUrl, {
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bareer ${localStorage.getItem("jwt")}`,
                    },
                    body: JSON.stringify({ projectObject: savedData }),
                    method: "POST",
                })
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.error) {
                            throw Error("Error while saving selection!");
                        }
                        toast.success(
                            `${t("The project is copied successfully")!}`,
                            {
                                position: toast.POSITION.TOP_CENTER,
                                autoClose: 2000,
                                theme: "colored",
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                icon: (
                                    <CheckboxIcon
                                        height={25}
                                        width={25}
                                        fill="white"
                                    />
                                ),
                            }
                        );
                        setIsModalLoadingOpened(false);
                        setKey(Math.floor(Math.random() * 10000));
                    })
            );
        } catch (e: any) {
            ErrorToast(t("There's an error"));
            setIsModalLoadingOpened(false);
        }
    }
    return (
        <ModalFooter className="border-top-0">
            <CustomSecondaryColorButton
                outline
                variant="light"
                onClick={() => {
                    setIsCreatedCoping(false);
                    setSelectedRows([]);
                }}
                rounded
            >
                {t("Cancel")}
            </CustomSecondaryColorButton>
            <CustomMainColorButton
                rounded
                className="mr-2"
                variant="primary"
                onClick={() => {
                    handleDuplicate();
                    setIsCreatedCoping(false);
                }}
            >
                {t("Validate")}
            </CustomMainColorButton>
        </ModalFooter>
    );
}
